let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("VCSNt")).then(() => parcelRequire('kZmg6'));